module.exports = __webpack_public_path__ + "static/media/vibes-n-tribes-podcast.3bbfcea6.md";